import { IS_DEVELOPMENT } from "./Environment";

export const DASH_LINKS = {
    assessment_excusals: IS_DEVELOPMENT
        ? "https://dev-student-excusals.dcsdk12.org/guardian" // /<studentNumber>
        : "https://student-excusals.dcsdk12.org/guardian",
    echeckin: IS_DEVELOPMENT
        ? "https://dev-echeckin.dcsdk12.org/guardian/echeckin" // /<studentNumber>
        : "https://echeckin.dcsdk12.org/guardian/echeckin",
    epr: IS_DEVELOPMENT ? "https://dev-reportcard.dcsdk12.org/guardian" : "https://reportcard.dcsdk12.org/guardian",
    epr_archive: "/epr-archive",
    guardian: IS_DEVELOPMENT ? "https://dev-engaged.dcsdk12.org" : "https://engaged.dcsdk12.org",
    legacy: IS_DEVELOPMENT ? "https://twpp-engaged.dcsdk12.org" : "https://engaged.dcsdk12.org",
    open_enrollment: IS_DEVELOPMENT
        ? "https://dev-open-enrollment.dcsdk12.org/guardian" // /home, /view/<studentNumberr>, /edit/<oeStudentKey>, /school-choice/<oeStudentKey>
        : "https://open-enrollment.dcsdk12.org/guardian",
    transportation: IS_DEVELOPMENT
        ? "https://dev-echeckin.dcsdk12.org/guardian/transportation" // /<studentNumber>
        : "https://echeckin.dcsdk12.org/guardian/transportation"
};
